
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temporary-storage-solutions",
      function () {
        return require("private-next-pages/temporary-storage-solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temporary-storage-solutions"])
      });
    }
  